import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './ui/command';
import { Button } from './ui/button';
import { CaretUpDown, Check } from '@phosphor-icons/react';

export function BuildingCombobox({ buildings, value, onValueChange, placeholder, className, triggerClassName, testId }) {
  const [open, setOpen] = useState(false);
  const selectedBuilding = buildings.find(b => b.building_id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={`w-full justify-between rounded-none font-normal ${!selectedBuilding ? 'text-zinc-400' : ''} ${triggerClassName || ''}`}
          data-testid={testId || 'building-combobox'}
        >
          <span className="truncate">{selectedBuilding ? selectedBuilding.name : (placeholder || 'Select building...')}</span>
          <CaretUpDown size={14} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder={placeholder || 'Search building...'} className="h-9" />
          <CommandList>
            <CommandEmpty>No building found.</CommandEmpty>
            <CommandGroup>
              {buildings.map(b => (
                <CommandItem
                  key={b.building_id}
                  value={b.name}
                  onSelect={() => { onValueChange(b.building_id); setOpen(false); }}
                  data-testid={`building-option-${b.building_id}`}
                >
                  <span className="flex-1 truncate">{b.name}</span>
                  {value === b.building_id && <Check size={14} className="ml-2 text-emerald-600" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
